import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import { css } from '@emotion/css';
import $, { event } from 'jquery';
import {
    REF_CURRENT_USER_ID,
    REF_KEYCLOAK_AUTH_TOKEN,
    REF_KEYCLOAK_REFRESH_TOKEN,
} from 'nexus-common/src/components/access/constants';
const cookies = new Cookies();
export const loginMessage = css`
    width: 90%;
    max-width: 800px;
    margin: 30vh auto 0 auto;
`;

export const containerStyle = css `
    display: flex;
    height: 100vh;
    background-color: white;
    margin:0;
    padding: 0;
`

export default class Login extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
        };

        this.doKeycloakLogin = this.doKeycloakLogin.bind(this);
    }

    componentDidMount() {
        const { keycloak } = this.props;
        const keycloakAuthToken = cookies.get(REF_KEYCLOAK_AUTH_TOKEN);
        const keycloakRefreshToken = cookies.get(REF_KEYCLOAK_REFRESH_TOKEN)
        if (keycloakAuthToken && keycloakRefreshToken) {
            this.props.loginHandler();
        }
        else {
            keycloak
                .init({ onLoad: 'login-required', checkLoginIframe: false })
                .then((authenticated: any) => {
                    this.doKeycloakLogin(keycloak.token, keycloak.refreshToken);
                    this.setupTokenRefresh(keycloak);
                })
                .catch((error: any) => {
                    console.log('kc error', error);
                });
        }
    }

    shouldComponentUpdate(nextProps: any, nextState: { userName: any; password: any }) {
        if (this.state.userName !== nextState.userName || this.state.password !== nextState.password) {
            return false;
        }
        return true;
    }
    setupTokenRefresh = (keycloak: any) => {
        const refreshInterval = keycloak.tokenParsed.exp - Date.now() / 1000 - 30; //30s before token expiration
        setTimeout(async () => {
            try {
                keycloak.updateToken(30).then(() => {
                    cookies.remove(REF_KEYCLOAK_AUTH_TOKEN, {domain: process.env.REACT_APP_COOKIE_DOMAIN, secure: true, sameSite: 'none'});
                    cookies.set(REF_KEYCLOAK_AUTH_TOKEN, keycloak.token, { domain: process.env.REACT_APP_COOKIE_DOMAIN, secure: true, sameSite: 'none' });
                });
            } catch (error) {
                console.error('Error refreshing token:', error);
            }
        }, refreshInterval * 1000);
    };

    doKeycloakLogin(token: any, refreshToken: any) {
        cookies.set(REF_KEYCLOAK_AUTH_TOKEN, token, { domain: process.env.REACT_APP_COOKIE_DOMAIN, secure: true, sameSite: 'none' });
        cookies.set(REF_KEYCLOAK_REFRESH_TOKEN, refreshToken, { domain: process.env.REACT_APP_COOKIE_DOMAIN, secure: true, sameSite: 'none' });
        this.props.loginHandler();
    }

    render() {
        const { newUser, userInfo } = this.state;
        if (newUser) {
            cookies.set('scientia_url', `${window.location.href}login`, {domain: process.env.REACT_APP_COOKIE_DOMAIN, secure: true, sameSite: 'none'})
            window.location.href = process.env.REACT_APP_CREATE_USER_URL || window.location.href        
        } else {
            return (
                <div className={containerStyle}>
                    <div className={loginMessage}>
                        <h2>Logging you into Science Central™, please wait...</h2>
                    </div>
                </div>
            );
        }
    }
}
